import React, { useState } from 'react';
import Select, { SelectOption } from '@amzn/meridian/select';
import Column from '@amzn/meridian/column';
import PropTypes from 'prop-types';
import { PLACEHOLDERS } from '../constants/FeedbackConstants';
import useResponse from '../hooks/useResponse';
import formatAnswerBasedOnType from '../utils/formatAnswerBasedOnType';
import Question from './Question';

/**
 * MultipleChoiceQuestion component will be used to provide the ability to select an option from the provided list of options.
 * @param {string} question - Question Text
 * @param {string[]} functionalities - The values of functionalities to choose from
 * @param {string} [placeholder = "Select a functionality"] -  Placeholder text in the select box
 * @returns Meridian Select Component
 */

const MultipleChoiceQuestion = ({
  question,
  id,
  isMandatory,
  functionalities,
  placeholder,
  questionTextFormat,
}) => {
  const [value, setValue] = useState();
  const { saveFeedbackResponse } = useResponse();

  const onChangeHandler = (functionality) => {
    setValue(functionality);
    // This is array now in backend. Hence formating to array
    const funtionalityValue = formatAnswerBasedOnType(functionality, true);
    saveFeedbackResponse({ id, answer: funtionalityValue });
  };
  return (
    <Column spacingInset="xxsmall">
      <Question questionTextFormat={questionTextFormat} question={question} isMandatory={isMandatory}></Question>
      <Select
        id="functionalities"
        value={value}
        onChange={(key) => onChangeHandler(key)}
        placeholder={placeholder}
        width={300}
        spacingInset="medium">
        {functionalities.map(({ optionNumber, optionValue }) => (
          <SelectOption
            key={optionNumber}
            label={optionValue}
            value={optionNumber}
          />
        ))}
      </Select>
    </Column>
  );
};

MultipleChoiceQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isMandatory: PropTypes.bool.isRequired,
  functionalities: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  questionTextFormat: PropTypes.string,
};

MultipleChoiceQuestion.defaultProps = {
  placeholder: PLACEHOLDERS.multipleChoiceQuestionType,
  questionTextFormat: '',
};

export default MultipleChoiceQuestion;
